import * as React from "react";
import { forwardRef } from "react";
const SvgFrame = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3 6H21M18 3V21M3 18H21M6 3V21", stroke: "#2C2D32", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgFrame);
export default ForwardRef;
